<template>
  <v-app :style="cssProps">
    <component :is="currentLayout" v-if="isRouterLoaded">
      <router-view></router-view>
    </component>

    <v-snackbar
      class="toast"
      :centered="true"
      v-model="toast.toast"
      :timeout="toast.timeout"
      @close="hideToast"
      absolute
      multi-line
    >
      {{ toast.toast_msg }}
    </v-snackbar>

    <v-dialog v-model="modal.on">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text v-html="modal.msg"> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="modal.on = false"> 닫기 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading" style="z-index: 999">
      <v-progress-circular
        :indeterminate="loading"
        color="white"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import AppLayout from '@/components/layout/AppLayout'
import AuthLayout from '@/components/layout/AuthLayout'
import StaffLayout from '@/components/layout/StaffLayout'
import SimpleLayout from '@/components/layout/SimpleLayout'
import MarketLayout from '@/components/layout/MarketLayout'
import GameLayout from '@/components/layout/GameLayout'

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`)

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})

export default {
  name: 'App',
  components: {
    AppLayout,
    AuthLayout,
    StaffLayout,
    SimpleLayout,
    MarketLayout,
    GameLayout,
  },
  computed: {
    cssProps() {
      return {
        '--primary-color': this.$vuetify.theme.themes.light.primary,
        '--error-color': this.$vuetify.theme.themes.light.error,
      }
    },
    is_login() {
      return this.$store.getters.is_login
    },
    loading() {
      return this.$store.getters.loading
    },
    toast() {
      return this.$store.getters.toast
    },
    modal() {
      return this.$store.getters.modal
    },
    isRouterLoaded: function () {
      if (this.$route.name !== null) return true

      return false
    },
    currentLayout: function () {
      const layout = this.$route.meta.layout || 'Simple'

      return (layout === 'Lotto' ? 'App' : layout) + 'Layout'
    },
  },
  created() {
    // this.$store.dispatch('FETCH_USERINFO')
    // this.$i18n.locale = 'en'
    this.$i18n.locale = 'ko'
    // const accessToken = this.$store.state.accessToken
    // const email = this.$store.state.user.email
    // loginSuccess(email, accessToken)
    // if (typeof window.androidBridge != 'undefined') {
    //   window.androidBridge.bridge_login_success(email, accessToken)
    // }
    // if (typeof window.webkit != 'undefined') {
    //   window.webkit.messageHandlers.login_success.postMessage({
    //     email: email,
    //     token: accessToken
    //   })
    // }
    // if (typeof loginSuccess == 'function') {
    //   loginSuccess(email, accessToken)
    // }
  },
  mounted() {
    this.$store.commit('loading', false)
    // this.$store.commit('activeMenu', this.$route.name)
    this.$store.commit('toast', {
      toast: false,
      toast_msg: '',
    })
    this.$store.commit('modal', { on: false, msg: '' })
    window.addEventListener('app_lang', this.app_lang, false)
  },
  beforeDestroy() {
    window.removeEventListener('app_lang', this.app_lang)
  },
  methods: {
    logout() {
      this.$store.commit('is_login', false)
      this.$router.push('/')
    },
    app_lang(lang) {
      // console.log(lang)
      if (lang && lang !== '') {
        this.$i18n.locale = lang
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/overrides.scss';
html,
body {
  width: 100%;
  height: 100%;
  color: #121212;
}
body {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', 'Noto Sans KR', -apple-system, BlinkMacSystemFont,
    'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',
    sans-serif;
}
a {
  text-decoration: none;
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.email-input input {
  text-transform: lowercase !important;
}
.swap-input-wrapper input {
  text-align: right !important;
}
.v-btn:before {
  background-color: inherit;
}
.theme--light.v-list-item--active::before,
.theme--light.v-tabs .v-tab--active::before {
  opacity: 0 !important;
}
.bottom-disable-p.theme--light.v-btn.v-btn--disabled,
.bottom-disable-p.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  opacity: 0.5 !important;
  background-color: var(--primary-color) !important;
  color: #fff !important;
}
.signup-container {
  padding: 4rem 2rem;
  height: 100%;
  overflow: auto;
}
.font-gray {
  color: #cbcbcb !important;
}
.font-70 {
  font-size: 1.45rem;
}
.font-60 {
  font-size: 1.25rem;
}
.font-46 {
  font-size: 0.95rem;
}
.font-44 {
  font-size: 0.83rem;
}
.font-40 {
  font-size: 0.8rem;
}
.v-application p {
  margin-bottom: 0;
  min-height: 22px;
}
.v-dialog--fullscreen {
  /* height: 100% !important; */
  box-shadow: none !important;
}
.toast {
  z-index: 300 !important;
}
.auth-container {
  position: fixed;
  height: 100%;
  // height: calc(100% - 55px);
  flex: 1;
  overflow: hidden;
}
.content-container {
  position: fixed;
  height: calc(100% - 56px);
  // margin-top: 84px;
  flex: 1;
  overflow: hidden;
}
.content-container::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.content-container {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.purple-wrapper {
  padding: 0 !important;
  height: 100%;
  overflow: auto;
  background-color: #3e0ba5;
}
.orange-wrapper {
  padding: 0 !important;
  height: 100%;
  overflow: auto;
  background-color:  hsl(36, 93%, 45%);
}
.white-wrapper {
  padding: 0 !important;
  height: calc(100% - 80px);
  overflow: auto;
  background-color: #fff;
}
.gray-wrapper {
  overflow: auto;
  padding: 0 !important;
  height: 100%;
  background-color: #f1f2f5;
}
.bottom-btn {
  position: fixed !important;
  left: 0;
  bottom: 55px;
  z-index: 3 !important;
}
.last-item {
  margin-bottom: 112px !important;
}
.last-item-one {
  margin-bottom: 56px !important;
}
.v-btn {
  height: inherit;
}
.v-btn__content {
  white-space: normal !important;
  width: 100%;
}
.v-card__text {
  line-height: inherit !important;
}
.send-slider .vue-slider-dot-handle {
  box-shadow: 0px 0px 1px 2px rgb(0 0 0 / 8%);
}
.staking-slider .vue-slider-dot-handle {
  box-shadow: none;
}
.rockup_list .v-list-item:hover::before {
  opacity: 0 !important;
}
.rockup_list .v-list-item-active:hover::before {
  opacity: 0 !important;
}
.swap_list .v-list-item:hover::before {
  opacity: 0 !important;
}
.swap_list .v-list-item-active:hover::before {
  opacity: 0 !important;
}
.v-menu__content {
  border-radius: 0 !important;
}
.news-content img {
  width: 100%;
  max-width: 50rem;
}
.v-expansion-panel-header__icon {
  margin-left: 0 !important;
  i {
    color: #121212 !important;
  }
}
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.v-card__text {
  color: #121212 !important;
}
.dialog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-title {
  font-weight: bold;
  margin-bottom: 1rem;
}
.dialog-text {
  font-size: 0.8rem;
  text-align: center;
}
.config-title {
  height: 5rem;
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.qr-code {
  display: flex;
  justify-content: center;
}
</style>
